module.exports = __webpack_public_path__ + "static/media/history_thu.d431acc3.png";